import { render, staticRenderFns } from "./scoreDia.vue?vue&type=template&id=74f7ef3c&scoped=true&"
import script from "./scoreDia.vue?vue&type=script&lang=js&"
export * from "./scoreDia.vue?vue&type=script&lang=js&"
import style0 from "./scoreDia.vue?vue&type=style&index=0&id=74f7ef3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f7ef3c",
  null
  
)

export default component.exports